import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faToolbox,
  faHandPaper,
  faHome,
  faCogs,
  faServer,
  faSignOutAlt,
  faInfoCircle,
  faMinusCircle,
  faPlus,
  faPlusCircle,
  faChevronRight,
  faChevronDown,
  faChevronLeft,
  faCalendarAlt,
  faSave,
  faTimes,
  faUnlock,
  faLock,
  faSearch,
  faMinus,
  faSpinner,
  faCheck,
  faChevronCircleLeft,
  faEye,
  faEyeSlash,
  faToggleOff,
  faToggleOn,
  faExchangeAlt,
  faKey,
  faHospitalAlt,
  faCloudUploadAlt,
  faTrash,
  faFileImport,
  faFileExport,
  faUpload,
  faEllipsisH,
  faRedoAlt,
  faExclamationTriangle,
  faCaretRight,
  faCaretUp,
  faCaretDown,
  faEdit,
  faPencilAlt,
  faBars,
  faSortAlphaUpAlt,
  faSortAlphaDown,
  faSortNumericUpAlt,
  faSortNumericDown,
  faExternalLinkAlt,
  faChartPie,
  faChartLine,
  faChartBar,
  faCircleNotch,
  faDownload,
  faGlobe,
  faClock,
  faExclamationCircle,
  faCheckCircle,
  faFlag,
  faPaperPlane,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';

import {
  faQuestionCircle,
} from '@fortawesome/free-regular-svg-icons';

import '@cordata/buffet/build/yup';
import './utils/yup';

import './styles/manifest.scss';
import App from './components/common/App';
import * as serviceWorker from './serviceWorker';

// Icons we can use: https://fontawesome.com/icons?d=gallery&m=free
library.add(
  faToolbox,
  faCheckCircle,
  faQuestionCircle,
  faHandPaper,
  faHome,
  faCogs,
  faServer,
  faSignOutAlt,
  faInfoCircle,
  faMinusCircle,
  faPlus,
  faPlusCircle,
  faChevronRight,
  faChevronLeft,
  faCalendarAlt,
  faChevronDown,
  faSave,
  faTimes,
  faUnlock,
  faLock,
  faSearch,
  faMinus,
  faSpinner,
  faCheck,
  faChevronCircleLeft,
  faEye,
  faEyeSlash,
  faToggleOff,
  faToggleOn,
  faExchangeAlt,
  faKey,
  faHospitalAlt,
  faCloudUploadAlt,
  faTrash,
  faFileImport,
  faFileExport,
  faUpload,
  faEllipsisH,
  faRedoAlt,
  faExclamationTriangle,
  faExclamationCircle,
  faPencilAlt,
  faEdit,
  faCaretRight,
  faCaretUp,
  faCaretDown,
  faBars,
  faSortAlphaUpAlt,
  faSortAlphaDown,
  faSortNumericUpAlt,
  faSortNumericDown,
  faExternalLinkAlt,
  faChartPie,
  faChartLine,
  faChartBar,
  faCircleNotch,
  faDownload,
  faGlobe,
  faClock,
  faFlag,
  faPaperPlane,
  faEnvelope,
);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
